var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYouTube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.902 5.171a2.86 2.86 0 0 0-2.012-2.024C19.116 2.668 12 2.668 12 2.668s-7.116 0-8.89.479A2.86 2.86 0 0 0 1.097 5.17C.622 6.958.622 10.684.622 10.684s0 3.727.476 5.513a2.82 2.82 0 0 0 2.011 1.992c1.775.479 8.89.479 8.89.479s7.117 0 8.891-.479a2.82 2.82 0 0 0 2.012-1.992c.476-1.786.476-5.513.476-5.513s0-3.726-.476-5.513m-13.23 8.897V7.3l5.948 3.383z"
})));
export default SvgYouTube;